export const navigationLinks = {
  links: [
    { name: "Register", to: "/register" },
    { name: "Login", to: "/login" },
  ],
};

export const privateNavigationLinks = {
  links: [
    // { name: "Dashboard", to: "/dashboard" },
    // { name: "Profile", to: "/profile" },
    { name: "Profile", to: "/me" },
    { name: "Home", to: "/" },
    { name: "Diary", to: "/diary" }
    // { name: "Secret", to: "/secret" },
  ],
};
